import React, { Fragment } from 'react';
import { Portal } from 'react-portal';
import {
  LoginLoading,
  OrderOverlay,
  OrderSpinner,
  OrderLoadingHeading,
  CartLoading,
  GeneralLoading,
  FullScreenContainer,
} from './style';

const FullLoadingPortal = ({ isLoading, message }) => (
  <Fragment>
    {isLoading && (
      <Portal>
        <FullScreenContainer>
          <GeneralLoading>{message}</GeneralLoading>
        </FullScreenContainer>
      </Portal>
    )}
  </Fragment>
);

export {
  LoginLoading,
  OrderOverlay,
  OrderSpinner,
  OrderLoadingHeading,
  CartLoading,
  GeneralLoading,
  FullLoadingPortal,
};



// WEBPACK FOOTER //
// ./src/components/loading/index.js